import React from 'react';
import PropTypes from 'prop-types';

const Page = ({children, title}) => {
    return (
        <div style={styles.container}>
            <div style={{display: 'none'}}>
                <h2>{title}</h2>
            </div>

            <div style={styles.body}>
                {children}
            </div>
        </div>
    );
}

Page.propTypes = {
    title: PropTypes.string.isRequired,
}

const styles = {
    container: {
        backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,1) 22%, rgba(108,234,255,1) 100%)',
        display: 'flex',
        height: '100vh',
        width: '100vw',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'scroll',
    },
    body: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
};

export default Page;
